// Random-Funktionalität bei Slider
if ($('.ttgNCESliderCouselRandom').length > 0) {
    $('.ttgNCESliderCouselRandom').each(function(index, value) {
        var sliderID = $(this).attr('id');

        if ($('#' + sliderID + '.carousel').length > 0) {
            //Bootstrap Carousel
            $('#' + sliderID + ' .slider .item').removeClass('active');
            $('#' + sliderID + ' .slider .item').shuffle();
            $('#' + sliderID + ' .slider .item:first-child').addClass('active');
        }
    });
}

// Random-Funktionalität ohne erstes Element bei Slider
if ($('.ttgNCESliderCouselRandomExceptFirst').length > 0) {
    $('.ttgNCESliderCouselRandomExceptFirst').each(function(index, value) {
        var sliderID = $(this).attr('id');

        if ($('#' + sliderID + '.carousel').length > 0) {
            //Bootstrap Carousel
            $('#' + sliderID + ' .item:not(.active)').shuffle();
        }
    });
}

//NCE Slider Video active Controls platzieren
$('.ttgNCESlider .carousel').on('slid.bs.carousel', function() {
    if ($(this).find('.item.active.runBabyRun').length) {
        $(this).addClass('ytMode');
    } else {
        $(this).removeClass('ytMode');
    }
});

$('.ttgNCESlider .carousel').on('slide.bs.carousel', function(e) {
    uid = $(this).data("id");

    $("#ttgNCESlider" + uid + " .carousel-indicators li.active").addClass("active-adjacent");
    $("#ttgNCESlider" + uid + " .carousel-indicators li.active").next().addClass("active-adjacent");
    $("#ttgNCESlider" + uid + " .carousel-indicators li.active").prev().addClass("active-adjacent");

    if (e.direction == "left") {
        $("#ttgNCESlider" + uid + " .carousel-indicators li.active").next().next().addClass("active-adjacent");
        $("#ttgNCESlider" + uid + " .carousel-indicators li.active").next().next().next().addClass("active-adjacent");
        $("#ttgNCESlider" + uid + " .carousel-indicators li.active").prev().prev().removeClass("active-adjacent");
    } else {
        $("#ttgNCESlider" + uid + " .carousel-indicators li.active").prev().prev().addClass("active-adjacent");
        $("#ttgNCESlider" + uid + " .carousel-indicators li.active").prev().prev().prev().addClass("active-adjacent");
        $("#ttgNCESlider" + uid + " .carousel-indicators li.active").next().next().removeClass("active-adjacent");
    }


});
